export const baseUrl = process.env.REACT_APP_API_2 || "";
export const baseUrlOrder = process.env.REACT_APP_API || "";
